import { API_BASE_PATH } from "@/constants/api";

/**
 * Typed access to build-time configuration for the preview build.
 *
 * There are no Supabase or Firebase keys: every request goes through the API
 * (Pages Function), which holds the service-role credential server-side.
 */
const read = (value: string | undefined, fallback = ""): string => (value ?? fallback).trim();

export const env = {
  appUrl: read(
    import.meta.env.VITE_APP_URL,
    typeof window === "undefined" ? "" : window.location.origin,
  ),
  apiBaseUrl: read(import.meta.env.VITE_API_BASE_URL, API_BASE_PATH),
  /** Workspace the dashboard CTA opens; falls back to the first one returned. */
  previewWorkspaceSlug: read(import.meta.env.VITE_PREVIEW_WORKSPACE_SLUG, "demo-catering"),
} as const;
